<div class="container">
  <div class="first-section">
    <div class="header-container">
      <span class="px-heading-3 first">{{ data.key ? 'Update' : 'New' }} product variable</span>
      <i class="material-icons close-icon" (click)="closeDialog()">close</i>
    </div>
  </div>
  <div class="section-container">
    <div class="section">
      <div class="px-heading-4">Product variable details</div>
      <div class="create-deepconfig-form">
        <form [formGroup]="dcForm" novalidate (ngSubmit)="onDcFormSubmit(dcForm.value)" class="form">
          <mat-dialog-content>
            <div class="nxt-input" *ngIf="!data.key">
              <mat-label class="nxt-label">Product variable name <span class="asterisk">*</span></mat-label>
              <div class="nxt-input-infix">
                <mat-form-field appearance="none" class="config-name p-0 mb-20" [hideRequiredMarker]="true">
                  <input matInput type="text" placeholder="Name" formControlName="key" required>
                  <mat-error class="error-msg">
                    <span *ngIf="dcForm.get('key').hasError('required') && dcForm.controls['key'].touched">
                      Please assign a name.
                    </span>
                    <span *ngIf="dcForm.get('key').hasError('invalidDcName') && dcForm.controls['key'].touched">
                      No spaces or special characters
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="nxt-input" *ngIf="!data.key">
              <mat-label class="nxt-label">Description</mat-label>
              <div class="nxt-input-infix">
                <mat-form-field appearance="none" class="p-0">
                  <input matInput #input type="text" placeholder="Description" formControlName="desc" [maxLength]="300">
                  <mat-hint align="end">{{input.value?.length || 0}}/300 characters</mat-hint>
                </mat-form-field>
              </div>
            </div>

            <div *ngIf="!data.key" class="default-value">
              <mat-label class="label">Data type <span class="asterisk">*</span></mat-label>
              <div>
                <mat-form-field appearance="none" class="p-0">
                  <mat-select placeholder="Data type" formControlName="type"
                    (selectionChange)="changeValueType(dcForm.value.type)">
                    <mat-option *ngFor="let valueType of availableValueTypes" [value]="valueType">
                      {{valueType}}
                    </mat-option>
                  </mat-select>
                  <mat-error>
                    <span *ngIf="!dcForm.controls['type'].valid && dcForm.controls['type'].touched">
                      Please pick a data type for product variable.
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div formGroupName="details">
              <div class="nxt-input" *ngIf="dcForm.value.type && dcForm.value.type==='Number'">
                <mat-label class="nxt-label">Default value <span class="asterisk">*</span></mat-label>
                <div class="nxt-input-infix">
                  <mat-form-field appearance="none" class="p-0">
                    <input type="number" matInput placeholder="Default value" formControlName="value">
                    <mat-error
                      *ngIf="dcForm.get('details.value').hasError('invalidNumber') && dcForm.get('details.value').touched">
                      {{dcForm.get('details.value').errors['invalidNumber']}}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="nxt-input" *ngIf="dcForm.value.type && dcForm.value.type==='String'">
                <mat-label class="nxt-label">Default value <span class="asterisk">*</span></mat-label>
                <div class="nxt-input-infix">
                  <mat-form-field appearance="none" class="p-0">
                    <input type="text" matInput placeholder="Default value" formControlName="value">
                  </mat-form-field>
                </div>
              </div>

              <div class="nxt-input" *ngIf="!dcForm.value.type">
                <mat-label class="nxt-label">Default value <span class="asterisk">*</span></mat-label>
                <div class="nxt-input-infix">
                  <mat-form-field appearance="none" class="p-0" *ngIf="!dcForm.value.type">
                    <input matInput placeholder="Default value" disabled>
                  </mat-form-field>
                </div>
              </div>

              <div *ngIf="dcForm.value.type && dcForm.value.type==='Boolean'">
                <mat-label class="nxt-label mt-10">Default value <span class="asterisk">*</span></mat-label>
                <div>
                  <mat-form-field appearance="none" class="p-0">
                    <mat-select placeholder="Default Value" formControlName="value">
                      <mat-option [value]="true">
                        True
                      </mat-option>
                      <mat-option [value]="false">
                        False
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div id="json-container" *ngIf="dcForm.value.type && dcForm.value.type==='JSON'">
                <div class="json-label mb-2"> Default value
                  <hansel-tag tagType="value" tagTxt="JSON"></hansel-tag>
                </div>
                <div ace-editor [(text)]="JSONValue" [mode]="'json'" [theme]="'chrome'" [readOnly]="false"
                  [autoUpdateContent]="true"
                  style="width: 328px; min-height: 200px; overflow: auto; border: 1px solid #ededed;"></div>
              </div>
            </div>

            <div class="nxt-input" *ngIf="data.key">
              <mat-label class="nxt-label">Description</mat-label>
              <div class="nxt-input-infix">
                <mat-form-field appearance="none" class="p-0">
                  <input matInput type="text" placeholder="Description" formControlName="desc" [maxLength]="300">
                  <mat-hint style="padding-bottom: 5px;" align="end">300 characters</mat-hint>
                </mat-form-field>
              </div>
            </div>
          </mat-dialog-content>
        </form>
      </div>
    </div>
  </div>
  <div class=" footer">
    <button class="px-primary-btn-xs done-btn" mat-flat-button [promiseBtn]="btnPromise" [disabled]="dcForm.invalid"
      (click)="onDcFormSubmit(dcForm.value)">save</button>
  </div>
</div>
